import { combineReducers } from 'redux';
// import { reducer as form } from 'redux-form';

import selectedSedeReducer from './selectedSede/reducer';

export default combineReducers({
  selected_sede: selectedSedeReducer,
});
